module.exports = __webpack_public_path__ + "images/ea80727b28c0099131e1421ceb34d89e.png";